module.exports = __webpack_public_path__ + "static/media/wind.edcde9bf.svg";